import { defaults } from 'lodash-es';
import type { ReactElement } from 'react';
import { Header } from './header/index.js';
import { Scaffold } from './scaffold.jsx';
import type { PlaceholderProps } from './types.js';
import { Placeholder as Bottom } from '#~/room/components/bottom-tray/index.js';
import { Placeholder as Left } from '#~/room/components/left-tray/index.js';
import { Placeholder as Right } from '#~/room/components/right-tray/index.js';
import { Placeholder as Top } from '#~/room/components/top-tray/index.js';

/** `<Placeholder>` component. */
export const Placeholder = ({ children, ...props }: PlaceholderProps): ReactElement => (
  <Scaffold
    {...defaults({}, props, {
      bottom: <Bottom />,
      header: <Header />,
      left: <Left />,
      right: <Right />,
      top: <Top />
    })}
  >
    {children}
  </Scaffold>
);
